import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PLATFORM_DEFAULTS_PATH = '/administration/platform-defaults';
const STORAGE_MAIN_TAB = 'platform_defaults_main_tab';
const STORAGE_SETTINGS_SUB_TAB = 'platform_defaults_settings_sub_tab';

/**
 * Clear platform-defaults tab state when navigating away so revisiting always lands on Subscriptions.
 * (Tab is still persisted on refresh because we only clear when pathname changes away.)
 */
export const usePlatformDefaultsTabCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== PLATFORM_DEFAULTS_PATH) {
      localStorage.removeItem(STORAGE_MAIN_TAB);
      localStorage.removeItem(STORAGE_SETTINGS_SUB_TAB);
    }
  }, [location.pathname]);
};
